export const SELECTION_GROUP_ID = 'SelectionGroupId';
export const SELECTION_ID = 'SelectionId';

// Ключи для хранения выбранных фильтров в разделе акций (selections) в sessionStorage/cookie
export const SELECTIONS_MULTICHECKBOX_FILTER_STORAGE = 'SelectionsMulticheckboxFiltersStorage';
export const SELECTIONS_RANGE_FILTER_STORAGE = 'SelectionsRangeFiltersStorage';
